var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isVisible
      ? _c("div", { staticClass: "c-modal" }, [
          _c("div", {
            staticClass: "c-modal__overlay",
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-modal__content" },
            [
              _c(
                "button",
                {
                  staticClass: "c-modal__close",
                  attrs: { type: "button" },
                  on: { click: _vm.close }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/icons/nav-close.svg"),
                      alt: "close"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "u-sr-only" }, [
                    _vm._v("Close Modal")
                  ])
                ]
              ),
              _vm._v(" "),
              _vm._t("content")
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }